import { render, staticRenderFns } from "./ClientSecrets.vue?vue&type=template&id=1a4d165a&"
import script from "./ClientSecrets.vue?vue&type=script&lang=js&"
export * from "./ClientSecrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports